import { EFinancingOfferRoute } from '@/types'
import { messages } from './messages'

export const ROUTES_WITH_SHOW_WIDGET: EFinancingOfferRoute[] = [
  EFinancingOfferRoute.main,
  EFinancingOfferRoute.MFOPage,
  EFinancingOfferRoute.advancePaymentOnFutureHarvest,
  EFinancingOfferRoute.sberRassrochka,
  EFinancingOfferRoute.oborotSber,
  EFinancingOfferRoute.centerInvestLoan,
  EFinancingOfferRoute.investSber,
  EFinancingOfferRoute.sberLeasing,
  EFinancingOfferRoute.interleasing,
  EFinancingOfferRoute.agriculturalMachinesAndEquipmentLeasing,
  EFinancingOfferRoute.fleetFinanceLeasing,
]

export const COMMENTS_MESSAGES: Partial<Record<EFinancingOfferRoute, string>> = {
  [EFinancingOfferRoute.main]: messages.comments.main,
  [EFinancingOfferRoute.MFOPage]: messages.comments.MFOPage,
  [EFinancingOfferRoute.advancePaymentOnFutureHarvest]: messages.comments.advancePaymentOnFutureHarvest,
  [EFinancingOfferRoute.sberRassrochka]: messages.comments.sberRassrochka,
  [EFinancingOfferRoute.oborotSber]: messages.comments.oborotSber,
  [EFinancingOfferRoute.centerInvestLoan]: messages.comments.centerInvestLoan,
  [EFinancingOfferRoute.sberLeasing]: messages.comments.sberLeasing,
  [EFinancingOfferRoute.investSber]: messages.comments.investSber,
  [EFinancingOfferRoute.interleasing]: messages.comments.interleasing,
  [EFinancingOfferRoute.agriculturalMachinesAndEquipmentLeasing]: messages.comments.agriculturalMachinesAndEquipmentLeasing,
  [EFinancingOfferRoute.fleetFinanceLeasing]: messages.comments.fleetFinanceLeasing,
}
